/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AuthSagasReloadViewerQueryVariables = {};
export type AuthSagasReloadViewerQueryResponse = {
    readonly viewer: {
        readonly userId: string;
        readonly username: string;
        readonly homeStation: string | null;
        readonly dispoDaysBefore: number | null;
        readonly dispoDaysAfter: number | null;
        readonly defaultLanguage: string | null;
        readonly printname: string | null;
        readonly defaultRegion: string | null;
        readonly enabledGroups: ReadonlyArray<{
            readonly vehicleGroupId: string;
            readonly description: string | null;
        } | null> | null;
        readonly enabledStations: ReadonlyArray<{
            readonly stationId: string | null;
            readonly name: string | null;
            readonly isChangeableInDispo: string | null;
        } | null> | null;
        readonly rights: ReadonlyArray<{
            readonly right: string | null;
        } | null> | null;
        readonly enabledRegions: ReadonlyArray<{
            readonly regionId: string | null;
            readonly regions: ReadonlyArray<{
                readonly regionId: string;
                readonly region: string | null;
                readonly enabledStations: ReadonlyArray<{
                    readonly stationId: string | null;
                } | null> | null;
            } | null> | null;
        } | null> | null;
        readonly hasMinimalRights: boolean | null;
        readonly tableDefinitions: ReadonlyArray<{
            readonly data: string;
            readonly formName: string;
            readonly gridName: string;
            readonly tableDefinitionId: string;
        } | null> | null;
        readonly emailSignature: string | null;
    } | null;
};
export type AuthSagasReloadViewerQuery = {
    readonly response: AuthSagasReloadViewerQueryResponse;
    readonly variables: AuthSagasReloadViewerQueryVariables;
};



/*
query AuthSagasReloadViewerQuery {
  viewer {
    userId
    username
    homeStation
    dispoDaysBefore
    dispoDaysAfter
    defaultLanguage
    printname
    defaultRegion
    enabledGroups {
      vehicleGroupId
      description
    }
    enabledStations {
      stationId
      name
      isChangeableInDispo
    }
    rights {
      right
    }
    enabledRegions {
      regionId
      regions {
        regionId
        region
        enabledStations {
          stationId
        }
      }
    }
    hasMinimalRights
    tableDefinitions {
      data
      formName
      gridName
      tableDefinitionId
    }
    emailSignature
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stationId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regionId",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "homeStation",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dispoDaysBefore",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dispoDaysAfter",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultLanguage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "printname",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultRegion",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VehicleGroup",
        "kind": "LinkedField",
        "name": "enabledGroups",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vehicleGroupId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Station",
        "kind": "LinkedField",
        "name": "enabledStations",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isChangeableInDispo",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Right",
        "kind": "LinkedField",
        "name": "rights",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "right",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DispositionRegion",
        "kind": "LinkedField",
        "name": "enabledRegions",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Region",
            "kind": "LinkedField",
            "name": "regions",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "region",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Station",
                "kind": "LinkedField",
                "name": "enabledStations",
                "plural": true,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasMinimalRights",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TableDefinition",
        "kind": "LinkedField",
        "name": "tableDefinitions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "data",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gridName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tableDefinitionId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailSignature",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthSagasReloadViewerQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AuthSagasReloadViewerQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c1990d94fe31fb2dffe81b6bbf1e572d",
    "id": null,
    "metadata": {},
    "name": "AuthSagasReloadViewerQuery",
    "operationKind": "query",
    "text": "query AuthSagasReloadViewerQuery {\n  viewer {\n    userId\n    username\n    homeStation\n    dispoDaysBefore\n    dispoDaysAfter\n    defaultLanguage\n    printname\n    defaultRegion\n    enabledGroups {\n      vehicleGroupId\n      description\n    }\n    enabledStations {\n      stationId\n      name\n      isChangeableInDispo\n    }\n    rights {\n      right\n    }\n    enabledRegions {\n      regionId\n      regions {\n        regionId\n        region\n        enabledStations {\n          stationId\n        }\n      }\n    }\n    hasMinimalRights\n    tableDefinitions {\n      data\n      formName\n      gridName\n      tableDefinitionId\n    }\n    emailSignature\n  }\n}\n"
  }
};
})();
(node as any).hash = '2703f8a37cea65c740f7cef628c805ed';
export default node;
